import { LANG } from '~/enums/Lang';
import { config as uiConfig } from '@common/ui-kit';
import {LANGUAGES} from "~/constants/langs";

export interface LanguageModel {
  id: number;
  name: string;
  original_name?: string | null;
  nativeName?: string | null;
  originalName?: string | null;
  isoCode?: string;
  iso_code?: string;
}

export const useLocaleStore = () => {
  const { setLocale: setI18nLocale } = useI18n();
  const switchLocalePath = useSwitchLocalePath();
  const localeCookie = useCookie('locale');
  const route = useRoute();
  const locale = useCookie('locale');
  const currentIsoCode = useState<LANG>('currentIsoCode', () => (route?.name as string)?.split('___')[1] as LANG || locale.value as LANG || LANG.EN);
  const currentLocaleId = useState<number>('currentLocaleId', () => 2);
  const languages = useState('languages', () => {
    return {
      data: LANGUAGES,
    }
  });

  const landingLocaleCookie = useCookie('landing_locale', {
    domain: '.sx.org',
    maxAge: 60 * 60 * 24 * 365,
  });

  onMounted(() => {
    if (!landingLocaleCookie.value) {
      landingLocaleCookie.value = currentIsoCode.value;
    }
  });

  const setUiConfigTranslates = () => {
    // uiConfig.uiLanguages.translations.modalSearchNotFound = t('Ничего не найдено');
    // uiConfig.uiLanguages.translations.searchInputPlaceholder = t('Поиск');
    // uiConfig.uiLanguages.translations.changeLanguage = t('Сменить язык');
  };

  const mappedLanguages = computed(() => {
    return languages.value.data.map((lang: LanguageModel) => {
      return {
        ...lang,
        nativeName: lang.originalName,
      };
    });
  });

  const currentLanguage = computed(() => {
    return languages.value.data.find((lang: LanguageModel) => lang.isoCode === currentIsoCode.value);
  });

  const setLocale = async (lang: LanguageModel) => {
    try {
      if (currentIsoCode.value !== lang.isoCode) {
        currentIsoCode.value = lang.isoCode as LANG;
        localeCookie.value = lang.isoCode;
        landingLocaleCookie.value = lang.isoCode;

        await setI18nLocale(lang.isoCode!);
        const newPath = switchLocalePath(lang.isoCode!);
        if (newPath) {
          await navigateTo(newPath);
        }
        
        setUiConfigTranslates();
      }
    } catch (err: any) {
      throw new Error(err);
    }
  };

  const visibleSxLangsModal = useState<boolean>('visibleSxLangsModal', () => false);

  return {
    currentIsoCode,
    currentLocaleId,
    languages,
    locale,
    visibleSxLangsModal,
    currentLanguage,
    mappedLanguages,
    setUiConfigTranslates,
    setLocale,
  }
}